import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from '@mui/icons-material';
import { IconButton, Button } from '@mui/material';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import Cartempty from '../Assets/images/empty cart.png'
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';
import loadingimg from '../Assets/images/loading image 1.png'
import tickimg from '../Assets/images/Group 15940 (1).png'
import useCartStore from '../DataRepo/CartStore';
import { CircularProgress, Drawer, Box, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import axios from 'axios'
import success from '../Assets/animations/success lottie.json'
import locIcon from '../Assets/images/orange_location_icon.png';
import elocIcon from '../Assets/images/edit_location_icon.png';
import blocIcon from '../Assets/images/location_icon.png'
import addimg from '../Assets/images/add icon 1.png'
import { getUserDetails } from '../Auth/AuthUtil';
import offerimg from '../Assets/images/offer.png'
import offerApplied from '../Assets/animations/offerapplied.json'
import Lottie from 'lottie-react';
import useAddressStore from '../DataRepo/AddressStore';
import paymentsuccess from '../Assets/Raw/paymentsuccess_ding.mp3'
import { shopModel } from '../Axios/AxiosConfig';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CloseIcon from '@mui/icons-material/Close';
import appointmentconfetti from '../Assets/animations/appointmentconfetti.json'
import uploadReportsimg from '../Assets/images/Frame 427319952.png'
import { amber } from '@mui/material/colors';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import { toast } from 'react-toastify';
import { encryptBody } from '../Axios/Middleware';

function Cart() {

    const navigate = useNavigate();

    const [hash, sethash] = useState('')

    const [coupon, setcoupon] = useState('')

    const [Transcation_id, setTranscation] = useState('')

    const [redeemcredits, setRedeemcredits] = useState(0)

    const [PendingOrders, setPendingOrders] = useState([])

    const { cartItems, updateQuantity, decreaseQuantity, isCartLoading, totalPrice, setDeliveryCharge, deliveryCharges, getCouponDetails, Coupons, CouponDetails, setCoupon, removeItem, getCart, clearCart, emptyCart, CouponErrorDetails, setCouponError, setCouponDetails } = useCartStore();

    const { currentAddress, getAddress } = useAddressStore();

    const [open, setOpen] = useState(false);

    const [open2, setOpen2] = useState(false);

    const [open3, setOpen3] = useState(false);

    const [calculatedTotalPrice, setCalculatedTotalPrice] = useState(0);

    const [state, setState] = useState({
        top: false,
        left: false,
        bottom: false,
        right: false,
    });

    const ringtone = new Audio(paymentsuccess)

    const coupondetails = CouponDetails

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClickOpen2 = () => {
        setOpen2(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleClose2 = () => {
        setOpen2(false);
    };

    const handleClickOpen3 = () => {
        setOpen3(true);
    };

    const handleClose3 = () => {
        setOpen3(false);
    };

    const userDetails = getUserDetails()

    useEffect(() => {
        const fetchData = async () => {
            const price = totalPrice();
            setCalculatedTotalPrice(price);
            await getCouponDetails('Shop', price);
        };

        fetchData();
    }, [cartItems, totalPrice]);

    useEffect(() => {
        getCart()
        getAddress()
    }, [])

    const initiatePayment = async () => {
        if (currentAddress) {
            try {
                const response = await shopModel.post('/makepayment',
                    {
                        amount: coupondetails?.couponType === 'percentage' ?
                            ((price + deliveryCharges) - ((price / 100) * discount)).toFixed(2) :
                            ((price + deliveryCharges) - (coupondetails?.cashRedeem || 0)),

                        // amount: '1',
                        txnid: Date.now().toString(),
                        phone: currentAddress?.Phone,
                        email: currentAddress?.Email,
                        productinfo: "Aiwell Products",
                        firstname: currentAddress?.Name,
                        "drop_category": "creditcard",
                        "enforce_paymethod": "netbanking|upi",
                    }
                );

                if (response?.status === 200) {
                    sethash(response?.data?.hash)
                    setTranscation(response?.data?.TranscationID)
                    handleClickOpen()
                    intiateOrderProcess()
                }
            }

            catch (error) {
                console.error('Error initiating payment:', error?.response);
            }
        }

        else {
            navigate('/Address')
        }
    };

    const handleCoupon = async (event) => {
        try {

            if (coupon) {
                await AvailCoupon(coupon, 'Shop', totalPrice(), event)
            }

            else {
                setCouponError({ error: "Please enter coupon" });
            }

        } catch (error) {
            console.error("handleCoupon: Error applying coupon", error);
        }
    };

    const deleteIntiateOrderProcess = async () => {

        try {

            const res = await shopModel.post('/api/v1/deleteintiateOrder',
                encryptBody({ pendingOrders: PendingOrders })
            );

            if (res?.status === 200) {
                setPendingOrders([]);
                sethash('');
                setTranscation('');
                handleClose();
                handleClose2();
                handleClose3();
                console.log("Order process deleted successfully");
            }
        } catch (err) {
            console.log("Error response:", err?.response?.data);
        }
    };

    const intiateOrderProcess = async () => {
        if (currentAddress) {
            try {
                let res = await shopModel.post('/api/v1/intiateOrderProcess', encryptBody({
                    Cart: cartItems,
                    discount,
                    couponId: coupondetails?.id || '',
                    Address: currentAddress
                }))

                if (res?.status === 200) {
                    const { results } = res.data;

                    handleClickOpen();

                    setPendingOrders(results);
                }
            }

            catch (err) {
                console.log(err?.response?.data)
            }
        }
        else {
            navigate('/Address')
            toast.error("Please add address to proceed")
        }

    };

    const Placeorder = async () => {
        try {

            let res = await shopModel.post('/api/v1/fullfillOrder', encryptBody({
                userid: userDetails?.UID,
                Orders: PendingOrders,
            }))

            if (res?.status === 200) {
                try { clearCart(); } catch (e) { console.error('clearCart failed', e); }

                try { handleClickOpen2(); } catch (e) { console.error('handleClickOpen2 failed', e); }

                try { handleClose(); } catch (e) { console.error('handleClose failed', e); }

                try { ringtone.play(); } catch (e) { console.error('ringtone.play failed', e); }

                try { setcoupon(''); } catch (e) { console.error('setcoupon failed', e); }

                try { setCouponDetails(null); } catch (e) { console.error('setCouponDetails failed', e); }

                try { emptyCart(); } catch (e) { console.error('emptyCart failed', e); }

                try {
                    setTimeout(() => {
                        try {
                            navigate('/MyOrders');
                        } catch (e) {
                            console.error('navigate failed', e);
                        }
                    }, 2500);
                }

                catch (e) {
                    console.log('setTimeout failed', e);
                }
            }

        }

        catch (err) {
            console.log(err?.response?.data)
        }
    };

    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setState({ ...state, [anchor]: open });
    };

    const price = parseInt(calculatedTotalPrice);

    const discount = coupondetails?.discount || 0;

    const [paymentStatus, setPaymentStatus] = useState(null);

    const invokePayPage = async (type) => {
        try {

            setPaymentStatus("processing");

            const amount = (
                (coupondetails?.couponType === 'percentage'
                    ? price - ((price / 100) * discount)
                    : price - (coupondetails?.cashRedeem || 0)
                ) + deliveryCharges
            ).toFixed(2)

            const encodedUdf2 = btoa(JSON.stringify({
                userid: userDetails?.UID,
                Orders: PendingOrders,
            }));

            const res = await shopModel.post("/api/v1/PhonePe/generate-token", encryptBody({
                amount,
                metaInfo: {
                    "udf1": "",
                    "udf2": "",
                },
            }));

            if (!res.data) {
                throw new Error("Token URL not received");
            }

            const callback = async (responseStatus) => {
                if (responseStatus === "USER_CANCEL" || responseStatus === "PAYMENT_ERROR") {
                    console.log(`Transaction failed or canceled: ${responseStatus}`);
                    setPaymentStatus("failure");
                    await deleteIntiateOrderProcess();
                } else if (responseStatus === "CONCLUDED") {
                    console.log("Transaction concluded successfully");
                    setPaymentStatus("success");
                    await Placeorder();
                } else {
                    console.warn("Unhandled responseStatus:", responseStatus);
                    setPaymentStatus("failure");
                    await deleteIntiateOrderProcess();
                }
            };

            if (
                typeof window !== "undefined" &&
                window.PhonePeCheckout &&
                typeof window.PhonePeCheckout.transact === "function"
            ) {
                window.PhonePeCheckout.transact({
                    tokenUrl: res.data.paymentUrl,
                    type,
                    callback,
                });
            } else {
                console.error("PhonePeCheckout or transact method not available");
                setPaymentStatus("failure");
            }

        } catch (error) {
            console.log("Error invoking PayPage:", error);
            setPaymentStatus("failure");
        }
    };

    const closePayPage = () => {
        if (window.PhonePeCheckout && window.PhonePeCheckout.closePage) {
            window.PhonePeCheckout.closePage();
            console.log("PayPage iFrame closed");
        } else {
            console.error("PhonePeCheckout closePage method not available");
        }
    };

    const AvailCoupon = async (coupon, applicableTo, total, event) => {
        try {


            const res = await shopModel.post('/api/v1/avail-coupon', {

                coupon,
                applicableTo,
                total
            });

            if (res?.status === 200) {
                setCouponDetails(res.data);

                setCouponError(null);

                handleClickOpen3();

                setTimeout(() => {
                    handleClose3()
                }, 3000)

                setcoupon('');

                toggleDrawer && toggleDrawer('right', false)(event);
            }
        } catch (err) {
            setCouponError(err?.response?.data);
            console.log(err);
        }
    };

    const list = (anchor) => (
        <Box sx={{
            width: (theme) => ({
                xs: '100%',
                sm: anchor === 'top' || anchor === 'bottom' ? 'auto' : 600,
                md: anchor === 'top' || anchor === 'bottom' ? 'auto' : 550,
            }),
        }}

            role="presentation"


        >

            <div className='p-5'>

                <div className=' flex' style={{ justifySelf: "flex-end" }} >
                    <IconButton onClick={toggleDrawer(anchor, false)}>
                        <CloseIcon></CloseIcon>
                    </IconButton>
                </div>

                <div className="coupon-container mb-5 mt-5">

                    <input type="text" placeholder="Enter your coupon code" className="coupon-input" onChange={(e) => {
                        setcoupon(e.target.value)
                        setCouponError(null)
                    }} />

                    <button className="apply-button" onClick={(event) => {
                        handleCoupon(event);
                    }}>
                        Apply Coupon
                    </button>

                </div>

                {CouponErrorDetails &&
                    <p className='couponError'>{CouponErrorDetails?.error}</p>
                }


                <div className='flex flex-col gap-5'>
                    {
                        Coupons?.validCoupons && Coupons?.validCoupons?.filter((e) => e?.Public).map((e) => {
                            return <div className='flex'>

                                <div id="main" style={{ borderTopLeftRadius: "15px", borderBottomLeftRadius: "15px" }}>
                                    <div class="top right"></div>
                                    <div class="bottom right"></div>

                                    <div className='p-5 h-full coupon-discount-card' style={{ writingMode: "sideways-lr", textAlign: "center" }}>
                                        {e?.couponType === 'percentage' ?
                                            <p>{e?.discount}% Discount</p> :
                                            <p>Flat ₹{e?.cashRedeem} off</p>}
                                    </div>

                                </div>

                                <div id="main2" style={{ borderTopRightRadius: "15px", borderBottomRightRadius: "15px" }}>
                                    <div class="top left"></div>
                                    <div class="bottom left"></div>

                                    <div className='coupon-card-details flex flex-col h-full'>

                                        <div className='p-5'>
                                            <h2>Coupon Code: {e?.couponName?.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}</h2>
                                            <div className='mt-5 cpninfotxt'>
                                                {
                                                    e?.couponType === 'percentage' ?
                                                        <p>Get {e?.discount}% discount for transaction above ₹{e.minValue}  </p> :
                                                        <p>Get Flat ₹{e.cashRedeem} off for transaction above ₹{e.minValue}</p>
                                                }
                                            </div>
                                        </div>

                                        <div className='p-3 mt-auto self-end w-full coupon-card-action'
                                            style={{ cursor: "pointer" }} onClick={(event) => {
                                                setCouponDetails(e)
                                                handleClickOpen3()
                                                setTimeout(() => {
                                                    handleClose3()
                                                }, 3000)
                                                toggleDrawer(anchor, false)(event)
                                            }}>
                                            <p className='text-right'>Apply</p>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        })
                    }

                    {
                        Coupons?.invalidCoupons && Coupons?.invalidCoupons?.filter((e) => e?.Public).map((e) => {
                            return <div className='flex'>

                                <div id="main" style={{ borderTopLeftRadius: "15px", borderBottomLeftRadius: "15px" }}>
                                    <div class="top right"></div>
                                    <div class="bottom right"></div>

                                    <div className='p-5 h-full coupon-discount-card' style={{ writingMode: "sideways-lr", textAlign: "center", backgroundColor: "#DFDFDE", color: "#A5A39D" }}>
                                        {e?.couponType === 'percentage' ?
                                            <p>{e?.discount}% Discount</p> :
                                            <p>Flat ₹{e?.cashRedeem} off</p>}
                                    </div>

                                </div>

                                <div id="main2" style={{ borderTopRightRadius: "15px", borderBottomRightRadius: "15px", backgroundColor: "#F4F4F4" }}>
                                    <div class="top left"></div>
                                    <div class="bottom left"></div>

                                    <div className='coupon-card-details flex flex-col h-full'>

                                        <div className='p-5'>
                                            <h2 style={{ color: "#BBBBBB" }}>Coupon Code: {e?.couponName?.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}</h2>

                                            <div className='mt-5 cpninfotxt' style={{ color: "#C7C7C7" }}>
                                                <p>Add products worth ₹{e?.minValue} to avail this deal! - Your health is the best investment</p>
                                            </div>

                                        </div>

                                        <div className='p-3 mt-auto self-end w-full coupon-card-action'>
                                            <p className='text-right' style={{ color: "#A5A39D" }}>Apply</p>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        })
                    }
                </div>

            </div>
        </Box>

    );

    return (
        <div className='All-products-section-main'>
            <nav className='flex flex-row p-2'>
                <IconButton onClick={() => navigate('/Shop')}>
                    <ChevronLeft />
                </IconButton>
                <p className='mb-0'>Cart</p>
            </nav>

            {isCartLoading ?
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100vw", height: '100vh' }}>
                    <div style={{ position: "relative", width: "10rem", height: "10rem" }}>
                        <CircularProgress style={{ width: "100%", height: "100%", color: "#DA6E0B" }} thickness={1} />
                        <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <img src={loadingimg} style={{ width: "80%", height: "80%" }} alt="Loading" />
                        </div>
                    </div>
                </div> :

                cartItems?.length > 0 ?
                    <div>

                        <div className='Cart-item-section'>

                            <div className='Cart-items-container'>
                                {cartItems?.map((e, i) => (
                                    <div key={i} className='Cart-item'>

                                        <div>
                                            <img src={e?.src} alt={e?.productName} style={{ mixBlendMode: "multiply" }} />
                                        </div>

                                        <div>
                                            <p className='mt-2 ml-1'>{e?.productName}</p>
                                            <p className='mt-2 ml-1'>{e?.desc}</p>
                                            <p className='mt-2 ml-1'>₹ {(e?.price)}</p>
                                        </div>

                                        <div>
                                            <IconButton onClick={() => {
                                                removeItem(e?.id)
                                            }}>
                                                <HighlightOffIcon />
                                            </IconButton>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-evenly' }}>
                                                <RemoveIcon
                                                    style={{ cursor: 'pointer' }}
                                                    fontSize='small'
                                                    onClick={(el) => {
                                                        el.stopPropagation();
                                                        decreaseQuantity(e?.id, userDetails?.UID);
                                                    }}
                                                />
                                                <span style={{ fontSize: '12px' }}>{e.quantity}</span>
                                                <AddIcon
                                                    style={{ cursor: 'pointer' }}
                                                    fontSize='small'
                                                    onClick={(el) => {
                                                        el.stopPropagation();
                                                        updateQuantity(e?.id, userDetails?.UID);
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className='Cart-items-info overflow-y-scroll'>

                                {!coupondetails &&
                                    <div className='flex items-center justify-between couponsandofferscontainer' style={{ cursor: "pointer" }}
                                        onClick={toggleDrawer("right", true)}>
                                        <p>View Coupons & Offers</p>
                                        <IconButton><ChevronRightIcon /></IconButton>
                                    </div>
                                }

                                {coupondetails &&
                                    <div className="CouponAppliedContainer">
                                        <div className="lottie-background">
                                            <Lottie animationData={offerApplied} />
                                        </div>
                                        <div className="content">
                                            <img src={offerimg} alt="Offer" />
                                            <div>

                                                <p>{coupondetails?.couponName?.toUpperCase()} Applied</p>

                                                {
                                                    coupondetails?.couponType === 'percentage' ?
                                                        <p>You have saved ₹{((price / 100) * discount).toFixed(0)} by applying a {discount}% discount for this order</p> :
                                                        <p>You have saved ₹{coupondetails?.cashRedeem} by applying a coupon for this order</p>
                                                }

                                            </div>
                                        </div>

                                        <IconButton style={{ alignSelf: "flex-start", justifySelf: "flex-end", marginLeft: 'auto' }} onClick={() => {
                                            setCouponDetails(null)
                                        }}>
                                            <HighlightOffIcon />
                                        </IconButton>
                                    </div>
                                }

                                {currentAddress &&
                                    <div className='Address-item flex flex-row justify-between mb-3'>
                                        <div className='flex flex-row justify-start'>
                                            <div className='locIcon'>
                                                <img src={locIcon} alt="Location Icon" />
                                            </div>
                                            <div className='Address-item-content'>
                                                <span>{currentAddress?.address_type}</span>
                                                <p>{currentAddress?.Name}</p>
                                                <p>{currentAddress?.address_details}</p>
                                                <p>{currentAddress?.Email}</p>
                                                <p>{currentAddress?.Phone}</p>
                                            </div>
                                        </div>
                                        <div
                                            className='locIcon'
                                            style={{ width: "2rem", cursor: "pointer" }}
                                            onClick={(el) => {
                                                el.stopPropagation();
                                                navigate('/Address')
                                            }
                                            }
                                        >
                                            <img src={elocIcon} alt="Edit Icon" />
                                        </div>
                                    </div>
                                }


                                {!currentAddress &&
                                    <div className='addAddressbtnct mb-3 p-6 cursor-pointer border border-[#DA6E0B] rounded-lg' onClick={() => {
                                        navigate('/Address')
                                    }}>
                                        <div>
                                            <img src={blocIcon} style={{ width: '20px' }}></img>
                                            <p>Add Delivery Address</p>
                                        </div>
                                        <div>
                                            <img src={addimg} style={{ width: '20px' }}></img>
                                        </div>
                                    </div>
                                }

                                <div className='Cart-total-container'>

                                    <div>
                                        <p>Order Details</p>
                                    </div>

                                    <div>

                                        <div>
                                            <p>Sub Total</p>
                                            <p>{`₹ ${calculatedTotalPrice}`}</p>
                                        </div>

                                        {
                                            coupondetails &&
                                            <div>
                                                <p>Coupon Discount</p>
                                                <p>- ₹{coupondetails?.couponType === 'percentage' ?
                                                    ((price / 100) * discount).toFixed(0) : (coupondetails?.cashRedeem || 0)}</p>
                                            </div>
                                        }

                                        <div>
                                            <p>Delivery Charges</p>
                                            <p>{`₹ ${deliveryCharges}`}</p>
                                        </div>

                                    </div>

                                    <div>
                                        <p>Total : <span>₹ {(
                                            (coupondetails?.couponType === 'percentage'
                                                ? price - ((price / 100) * discount)
                                                : price - (coupondetails?.cashRedeem || 0)
                                            ) + deliveryCharges
                                        ).toFixed(0)
                                        }
                                        </span>
                                        </p>
                                    </div>

                                </div>
                            </div>

                            <Drawer
                                anchor={'right'}
                                open={state['right']}
                                onClose={toggleDrawer('right', false)}
                            >
                                {list('right')}
                            </Drawer>

                        </div>

                        <div className='Cart-checkout-section'>

                            <div>
                                <p>Total : <span>₹ {(
                                    (coupondetails?.couponType === 'percentage'
                                        ? price - ((price / 100) * discount)
                                        : price - (coupondetails?.cashRedeem || 0)
                                    ) + deliveryCharges
                                ).toFixed(0)
                                }</span>
                                </p>
                                <p>View details</p>
                            </div>

                            <div>
                                <div>
                                    <Button
                                        style={{
                                            // width: '100%',
                                            textTransform: 'none',
                                            backgroundColor: '#DA6E0B',
                                            color: '#FDFDFD',
                                            border: '1px solid #DA6E0B',
                                            boxSizing: 'border-box',
                                            borderRadius: "5px",
                                            fontFamily: "'Poppins', sans-serif",
                                            fontWeight: 500,
                                            padding: "10px 2rem"
                                        }}

                                        onClick={() => {
                                            intiateOrderProcess()

                                        }}

                                    >
                                        {currentAddress ? ((price / 100) * discount).toFixed(0) < 0 ? 'Proceed to confirm' : 'Proceed to pay' : 'Add Address'}
                                    </Button>
                                </div>
                            </div>

                        </div>

                    </div> :

                    <div className='EmptyCart'>
                        <img src={Cartempty}></img>

                        <p>Your Cart is Empty</p>
                        <p>"Boost your wellness—shop your favorites now!"</p>

                        <div>
                            <Button
                                style={{
                                    width: '100%',
                                    textTransform: 'none',
                                    backgroundColor: '#FDFDFD',
                                    color: '#DA6E0B',
                                    border: '1px solid #DA6E0B',
                                    boxSizing: 'border-box',
                                    borderRadius: "5px",
                                    fontFamily: "'Poppins', sans-serif",
                                    fontWeight: 500,
                                    padding: "10px"
                                }}
                                onClick={() => navigate('/Shop')}
                            >
                                View Products
                            </Button>
                        </div>

                    </div>
            }

            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title" className='flex items-center gap-2'>
                    <ShoppingBagOutlinedIcon style={{
                        color: "#75623F", fontSize: "2rem"
                    }}></ShoppingBagOutlinedIcon> Confirm Order
                </DialogTitle>

                <DialogContent>
                    <DialogContentText id="alert-dialog-description" >
                        Takes 5-7 working days to deliver the product!
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <>
                        <Button
                            style={{
                                // width: '100%',
                                textTransform: 'none',
                                borderRadius: '0',
                                border: '1px solid #DA6E0B ',
                                color: '#DA6E0B',
                                boxSizing: 'border-box',
                                borderRadius: '5px',
                                fontFamily: "'Poppins', sans-serif",
                                fontWeight: 500,
                                padding: '10px'
                            }}
                            onClick={handleClose}>Cancel</Button>

                        <Button
                            style={{
                                // width: '100%',
                                textTransform: 'none',
                                borderRadius: '0',
                                backgroundColor: '#DA6E0B',
                                color: 'white',
                                border: 'none',
                                boxSizing: 'border-box',
                                borderRadius: '5px',
                                fontFamily: "'Poppins', sans-serif",
                                fontWeight: 500,
                                padding: '10px'
                            }}

                            onClick={() => {
                                invokePayPage('IFRAME')
                                handleClose()
                            }}

                        >
                            Confirm
                        </Button>
                    </>

                </DialogActions>
            </Dialog>

            <Dialog
                open={open2}
                onClose={handleClose2}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                    <div className='Appointment-booked-success'>
                        <Lottie animationData={success} loop={false}></Lottie>
                        <p>Order Placed Successfully</p>
                    </div>
                </DialogContent>
            </Dialog>

            <Dialog
                open={open3}
                onClose={handleClose3}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    style: { borderRadius: '10px', overflow: 'hidden' }
                }}
            >
                <DialogContent className='cpndialogbg'>

                    <div className="Lottie-background">
                        <Lottie animationData={appointmentconfetti}></Lottie>
                    </div>

                    {/* <div className='flex justify-end'>
                        <IconButton onClick={handleClose3}>
                            <CloseIcon></CloseIcon>
                        </IconButton>
                    </div> */}

                    <div className='flex flex-col items-center gap-3 justify-center'>

                        <img src={tickimg} style={{ width: '5rem' }}>
                        </img>

                        <div className='uploadimgreportinfo text-center'>
                            <p >Congrats!</p>
                        </div>

                        <div className='flex p-5 cpnapplied'>
                            <p>{coupondetails?.couponName?.toUpperCase()} Coupon is Applied</p>
                        </div>

                        <div className='cpnsaved'>
                            <p>You have saved ₹{coupondetails?.couponType === 'percentage' ?
                                ((price / 100) * discount).toFixed(0) : (coupondetails?.cashRedeem || 0)}</p>
                        </div>

                    </div>
                </DialogContent>
            </Dialog>

        </div>
    );
}

export default Cart;
